import React, { FunctionComponent } from 'react'
import { IProps } from './IProps'
import { Icon } from 'components/PricingCrud/style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const ActionButtons: FunctionComponent<IProps> = ({
  deleteService,
  addService,
  serviceIndex,
  category,
  categoryPosition,
}) => {
  return (
    <>
      <Icon onClick={() => deleteService(serviceIndex, category, categoryPosition)} className={`delete`}>
        <FontAwesomeIcon icon={'circle-minus'} />
      </Icon>
      <Icon onClick={() => addService(serviceIndex, category, categoryPosition)} className={`add`}>
        <FontAwesomeIcon icon={'circle-plus'} />
      </Icon>
    </>
  )
}
